var map = {
	"./1-off.png": "da6a",
	"./1-on.png": "1d0c",
	"./10-off.png": "17e9",
	"./10-on.png": "7435",
	"./11-off.png": "edae",
	"./11-on.png": "c8f3",
	"./2-off.png": "c93a",
	"./2-on.png": "be33",
	"./3-off.png": "9c39",
	"./3-on.png": "d455",
	"./4-off.png": "b530",
	"./4-on.png": "9d06",
	"./5-off.png": "adda",
	"./5-on.png": "f765",
	"./6-off.png": "a532",
	"./6-on.png": "08b4",
	"./7-off.png": "eb8a",
	"./7-on.png": "06b9",
	"./8-off.png": "7955",
	"./8-on.png": "4e46",
	"./9-off.png": "ee8b",
	"./9-on.png": "10b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5140";